import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import ConsumerMenu from 'components/consumer/consumer-menu';

// An instance of ConsumerMenu for the layout named NewSubMenuLayout
const NewSubMenuLayoutMenu = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ConsumerMenu config={{
      isAltSubMenu: true,
      navlinks: [{
        title: "Story",
        link: "/about-us"
      }, {
        title: "Workshop",
        link: "/the-factory"
      }, {
        title: "Quality",
        link: "/quality"
      }, {
        title: "Reviews",
        link: "/reviews"
      }, {
        title: "Giving Back",
        link: "/giving-back"
      }, {
        title: "Press",
        link: "/press"
      }, {
        title: "Jobs",
        link: "/careers"
      }]
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(NewSubMenuLayoutMenu);